module.exports = __webpack_public_path__ + "img/logo_sk_en_black.9bf19d60.png";